import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () => createStyles({});

export type Styles = WithStyles<typeof styles>;
